import React from 'react';
import { get } from 'lodash'

import { withFilterCars } from '../../../shared/containers/containerFilterCars'

import ButtonMediumDefault from '../../../shared/items/contols/buttonMediumDefault'

const ClearCarsFilter = props => {
  const { onHandleClearFilter, filterCarsListItems } = props

  return (
    get(filterCarsListItems, ["filterCount"], 0) !== 0
      ? <ButtonMediumDefault title="Сбросить" handleClick={onHandleClearFilter} />
      : null
  )
}

export default withFilterCars(React.memo(ClearCarsFilter))
